import type { TaskComment } from "@/api/tasks";

/** REST and live events can repeat rows; separate completed turns keep their IDs. */
export function dedupeTaskComments(comments: TaskComment[]): TaskComment[] {
  const seen = new Set<string>();
  return comments.filter((comment) => {
    if (seen.has(comment.id)) return false;
    seen.add(comment.id);
    return true;
  });
}
